module.exports = __webpack_public_path__ + "img/facettedconnections.d4571e7.jpg";